import client from '../api/client.js'

export const fetchUserSubOrgsRequest = async (userId) => {
  const response = await client.get(`/users/${userId}/suborgs`)
  return response?.data
}

export const addUserSubOrgRequest = async (userId, subOrgId) => {
  const response = await client.post(`/users/${userId}/suborgs`, {
    sub_org_id: subOrgId,
    role: 'user',
  })
  return response?.data
}

export const removeUserSubOrgRequest = async (userId, subOrgId) => {
  await client.delete(`/users/${userId}/suborgs/${subOrgId}`)
  return true
}

export const updateMyProfileRequest = async (payload) => {
  const response = await client.patch('/users/me', payload)
  return response?.data
}

export const changeMyPasswordRequest = async (currentPassword, newPassword) => {
  const response = await client.post('/users/me/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  })
  return response?.data
}

